// @import dependencies
import React, { CSSProperties } from 'react'
import { AiOutlineQuestionCircle } from 'react-icons/ai';
import TooltipComponent from '../TooltipComponent/TooltipComponent';
// @end dependencies

// @import components
// @end components

// @import types
// @end types

// @import services
// @end services

// @import hooks
// @end hooks

// @import actions
// @end actions

// @import utils
// @end utils

// @import styles
import './TextComponent.scss'
// @end styles

interface ITextComponentProps extends CSSProperties {
  type?: 'title' | 'subtitle' | 'text' | 'button' | 'paragraph'
  as?: 'p' | 'span' | 'h2'
  children?: any
  className?: string
  style?: CSSProperties
  styleDiv?: CSSProperties
  elipsis?: boolean
  helpText?: string
  id?: string
  onClick?: () => void
}

const TextComponent: React.FC<ITextComponentProps> = ({
  type,
  as,
  children,
  className,
  style,
  styleDiv,
  elipsis,
  helpText,
  onClick,
  id,
  ...overrideStyles
}) => {
  type = type ? type : 'text'
  return(
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        ...styleDiv
      }}
      onClick={onClick}
      id={id}
    >
      {helpText ?
        <TooltipComponent
          text={helpText}
        >
          <AiOutlineQuestionCircle
            style={{
              fontSize: '1.2rem',
              color: 'black',
              cursor: 'pointer'
            }}
          />
        </TooltipComponent>
      : null}
      {as === 'span' ?
        <span
          className={`text_component-layout ${elipsis ? 'elipsis' : ''} ${type} ${className ? className : ''}`}
          style={{ ...overrideStyles, ...style }}
        >
          {children}
        </span>
      : as === 'h2' ?
        <h2
          className={`text_component-layout ${elipsis ? 'elipsis' : ''} ${type} ${className ? className : ''}`}
          style={{ ...overrideStyles, ...style }}
        >
          {children}
        </h2>
      :
        <p
          className={`text_component-layout ${elipsis ? 'elipsis' : ''} ${type} ${className ? className : ''}`}
          style={{ ...overrideStyles, ...style }}
        >
          {children}
        </p>
      }
    </div>
  );
}

export default TextComponent;
